// src/Footer.js
import React from "react";
import "./Footer.css"; // Import CSS for styling
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  return (
    <footer className="footer">
      <div className="footer-left"></div>
      <div className="footer-center">
        <p>&copy; Copyright 2025. All Rights Reserved.</p>
      </div>
      <div className="footer-right">
        <p
          className="text-info"
          style={{ cursor: "pointer", fontSize: "larger" }}
          onClick={() => {
            navigate("/contact-us");
          }}
        >
          <b>Having an issue?</b>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
